import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { TokenService } from 'src/app/token.service';

@Injectable({
  providedIn: 'root'
})
export class VmsVendorService {

  httpUrl:any;
 notify_count :any = 0;
  constructor(private http: HttpClient, private main: MainService, public token: TokenService) {
    this.httpUrl = this.main.httpUrl + '/street/vendor-admin';

   }


   async gettingVendorList(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/getVendorList' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    })
    return res;
  }

  async view_document(obj :any) {
    console.log(obj, "from service")
    const resp = await this.http.post(this.main.httpUrl  + '/street/vendor-admin/view_document', obj, { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }

  async approved_license(obj: any) {
    const res = await this.http.post<any>(this.httpUrl + '/approved_license' , obj).toPromise().then(res => {
      return res;
    })
    return res;
  }
  async familly_details(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/familydetails' + obj).toPromise().then(res => {
      return res;
    })
    return res;
  }
  async add_remark(obj: any) {
    const res = await this.http.post<any>(this.httpUrl + '/add_reamrk' , obj).toPromise().then(res => {
      return res;
    })
    return res;
  }
  async get_notification(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/all_notification' + obj).toPromise().then(res => {
      return res;
    })
    return res;
  }
  async update_notify(obj: any) {
    const res = await this.http.post<any>(this.httpUrl + '/street_update_notification' , obj).toPromise().then(res => {
      return res;
    })
    return res;
  }
}
